export default __webpack_public_path__ + "static/home-background-sm-0c19e39def397ccc4b667471d4a53a1d.jpg";